// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__go1f3","dragIcon":"SortableItem_dragIcon__3J8VZ","disabled":"SortableItem_disabled__2OsW-"};